import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate, NuInput, NuTextArea } from '../../../../Components/Utils/Input';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import UseCustomerDropDownNew from '../../../../Components/Hooks/useCustomerSearch';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import { useToast } from '../../../../Components/Others/ToastServices';
import axiosInstance from '../../../../Services/axiosCommon';
import { GetAccess, GetNotUseRole, GetUseRole } from '../../../../Components/Utils/roles';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];


function CreateClientTickets() {
  const navigate = useNavigate();
  const {  addFormData , isLoading} = useAddFormData();
  const toast = useToast();
      const [image, setImage] = useState([]);
     const [selectedFile, setSelectedFile] = useState(null);
        const [searchClient, setSearchClient] = useState("");
  
  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );

  const { value: Status,getData:refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Support_Tickets"
  ); 
  const { value: TicketType,getData:refTicketType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Ticket_Type"
  );  

  const { value: Priority,getData:refPriority } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "priority"
  );  

        
     const [createNew, setCreateNew] = useState({
      contractId:null,
      subject:"",
      message:"",
      clientId:null,
      ticketType:"",
      priority:"",
      status:"",
      attachments: [],

  });

 function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // clientId: yup.string().required("Client is required!"),
      contractId: yup.string().required("Contract is required!"),
      
          }),
    onSubmit: async (value, { resetForm }) => {

      let formData = new FormData();
      const valueWithProducts = {
        ...value,
        // products: productsString,
        // services: servicesString,
        // emails: emailsString,
      };
      formData.append("json_data", JSON.stringify(valueWithProducts));
      // formData.append("attachments", image.raw);
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
                  await addFormData({url:`/tickets/raise-ticket`, formData:formData,navigateUrl:`/tickets/client-tickets`,resetForm:resetForm   });

          //  addFormData("/tickets/raise-ticket ", formData, resetForm);
    },
  });
 
 const [Newcontract, setContract] = useState([]);
 const [clientId, setClientId] = useState(null);

function getContractsByClientId(clientId) {
  if (!clientId) return;

  axiosInstance
    .get(`/contract/drop-down/client/${clientId}`)
    .then((res) => {
      const formatted = res.data?.map(item => ({
        value: item.id,
        label: item.name,
      })) || [];
      setContract(formatted);
    })
    .catch(err => {
      console.error("Error fetching contracts by client ID:", err);
      setContract([]);
    });
}

function getContractsForClientUser() {
  axiosInstance
    .get(`/tickets/get-clientId`)
    .then((res) => {
      let client = res.data?.client;
      getContractsByClientId(client);
    })
    .catch(err => {
      console.error("Error fetching contracts for client user:", err);
    });
}

useEffect(() => {
  if (GetNotUseRole("client")) {
    if (formik.values.clientId) {
      getContractsByClientId(formik.values.clientId);
    }
  }
}, [formik.values.clientId]);

useEffect(() => {
  if (GetUseRole("client")) {
    getContractsForClientUser();
  }
}, []);

  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full"> 
         <Breadcrumb
                  items={[
                    // { name: "Testing&Commissioning" },
                    {   name: "Client-Tickets" ,
                      link:"/tickets/client-tickets"
                    },
                    { name: "Create" },
                  ]}
                />         
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
                         <SettingHeading title="Client Ticket "  />
             
            </div>
            {/* <FormikSelectTwo
              label="Type"
              Options={[
                { value: "Contractual", label: "Contractual" },
      { value: "Non-Contractual", label: "Non-Contractual" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Type"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            /> */}
            {GetNotUseRole("client") && (

           <FormikSelectTwo
                         label="Client"
                         Options={client}
                         formik={formik}
                         placeholder="Choose"
                         name="clientId"
                         isRequired={true}
           
                         width="w-full md:w-1/3 md:-mt-2"
                       />
            )}

<FormikSelectTwo
              label="Contract "
              Options={Newcontract}
              formik={formik}
              placeholder="Choose"
              name="contractId"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />

             <NuInput
             type="text"
              label="Subject"
      //         Options={[
      //           { value: "project1", label: "Project X" },
      // { value: "project2", label: "Project Y" },
      //         ]}
              formik={formik}
              placeholder="Choose"
              name="subject"

              width="w-full md:w-1/3 md:-mt-2"
            />

<FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"

              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Priority"}
              propertyName={"priority"}
              getFunc={refPriority}

            /> 

<DropDownAddMetaData
              label="Ticket Type"
              Options={TicketType}
              formik={formik}
              placeholder="Choose"
              name="ticketType"

              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Ticket Type"}
              propertyName={"Ticket_Type"}
              getFunc={refTicketType}
              
            /> 

             {/* <DropDownAddMetaData
                          label="Status"
                          Options={Status}
                          formik={formik}
                          placeholder="Choose"
                          name="status"
            
                          width="w-full md:w-1/3 md:-mt-2"
                          displayProperty={"Status"}
                          propertyName={"Status_Support_Tickets"}
                          getFunc={refStatus}
            
                        />  */}

             <NuTextArea
                          type="text"
                          label="Message"
                          placeholder="Message"
                          formik={formik}
                          name="message"
                          width="w-full md:w-1/2 "
                        />

<Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach" 
                multiple={true}
                removeImages={removeImages}
              />
            {/* <NuDate
              label="Ticket Date"
              placeholder="Ticket Date"
              formik={formik}
              name="TicketDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            />

<NuDate
              label="Response Date"
              placeholder="Response Date"
              formik={formik}
              name="ResponseDate"
             
              width="w-full md:w-1/3 md:-mt-2"
            /> */}

{/* <DropDownAddMetaData
              label="Status"
              Options={[
                { value: "Pending", label: "Pending" },
      { value: "Completed", label: "Completed" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="Status"
              isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
              displayProperty={"Status"}
              propertyName={"Status"}
            /> */}
           
           
           <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                 <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateClientTickets
